/* Thumbnail clicking.

   Three bugs, all now fixed here:

   1. The thumbnails were dead. Nothing overlaid them — the section binds its handlers at
      parse time and luma-fx.js afterwards rebuilds the gallery, replacing those nodes, so
      the new tiles carry none. Fixed with a delegated listener on document, which
      survives any number of rebuilds.

   2. My first fix then swapped the main <img>'s src — wrong, because .main is a
      horizontal SLIDER holding every photo side by side, not one image.

   3. The fix after THAT scrolled to `index * clientWidth`, which assumed the track starts
      at scroll origin 0. It did not: `justify-content:center` had pushed it 1885px into
      negative scroll space (see luma-buybox.js), so every click landed on the wrong photo
      and the first three could not be reached at all. buybox now sets flex-start, and the
      scroll target below is measured from the slide itself rather than assumed from its
      index — so it stays correct even if padding, gap or centring ever come back. */
(function(){

/* exact scroll position that puts slide i flush against the left edge, measured live.
   rect-delta + current scrollLeft is immune to padding, gap and offsetParent changes. */
function slideLeft(main, i){
  var k = main.children[i];
  if(!k) return i * main.clientWidth;
  return main.scrollLeft + (k.getBoundingClientRect().left - main.getBoundingClientRect().left);
}

/* which slide is currently showing — nearest slide to the current scroll position */
function currentIndex(main){
  var best = 0, bestD = Infinity;
  for(var i = 0; i < main.children.length; i++){
    var d = Math.abs(slideLeft(main, i) - main.scrollLeft);
    if(d < bestD){ bestD = d; best = i; }
  }
  return best;
}

function railAndIndex(tile){
  var rail=tile.parentNode;
  var tiles=[].slice.call(rail.querySelectorAll('.t'));
  return { rail: rail, index: tiles.indexOf(tile), tiles: tiles };
}

function mark(tiles, idx){
  tiles.forEach(function(t,i){ t.classList.toggle('on', i===idx); });
}

document.addEventListener('click', function(e){
  var tile = e.target.closest && e.target.closest('.lp .thumbs .t');
  if(!tile) return;
  var main = document.querySelector('.lp .wrap .main');
  if(!main) return;

  var info = railAndIndex(tile);
  if(info.index < 0) return;

  main.scrollTo({ left: slideLeft(main, info.index), behavior: 'smooth' });
  mark(info.tiles, info.index);
}, false);

/* if the shopper swipes or drags the slider, move the outline to match */
function watchScroll(){
  var main = document.querySelector('.lp .wrap .main');
  if(!main || main.dataset.lumaScroll) return;
  main.dataset.lumaScroll = '1';
  main.addEventListener('scroll', function(){
    clearTimeout(window.__lumaScrollT);
    window.__lumaScrollT = setTimeout(function(){
      var tiles = [].slice.call(document.querySelectorAll('.lp .thumbs .t'));
      if(tiles.length) mark(tiles, currentIndex(main));
    }, 120);
  }, { passive: true });
}

/* keyboard access - the tiles are divs, not buttons */
document.addEventListener('keydown', function(e){
  if(e.key!=='Enter' && e.key!==' ') return;
  var tile = document.activeElement && document.activeElement.closest && document.activeElement.closest('.lp .thumbs .t');
  if(tile){ e.preventDefault(); tile.click(); }
});

function a11y(){
  document.querySelectorAll('.lp .thumbs .t').forEach(function(t){
    if(!t.hasAttribute('tabindex')){ t.setAttribute('tabindex','0'); t.setAttribute('role','button'); }
  });
  watchScroll();
}
document.addEventListener('DOMContentLoaded',function(){ [200,900,2000,3200].forEach(function(d){ setTimeout(a11y,d); }); });
window.addEventListener('load',function(){ setTimeout(a11y,300); });
})();